import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import localeEsMx from '@angular/common/locales/es-MX';
import { ComponentsModule } from './pages/components/components.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagesUiModule } from './pages/pages-ui/pages-ui.module';
import { AlertaModule } from './shared/alerta/alerta.module';
import { LoaderModule } from './shared/loader/loader.module';
import { JwtInterceptor } from './auth/interceptor/jwt.interceptor';

import { AsignacionEnfermeraCasoclinicoComponent } from './dialogs/asignacion-enfermera-casoclinico/asignacion-enfermera-casoclinico.component';

registerLocaleData(localeEsMx);

@NgModule({
  declarations: [
    AppComponent,
    AsignacionEnfermeraCasoclinicoComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    ComponentsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    PagesUiModule,
    AlertaModule,
    LoaderModule,
    ToastModule,
    ReactiveFormsModule,
    DropdownModule
  ],
 
  providers: [
    {provide: LOCALE_ID, useValue: 'es-mx'},
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
